export default {
  loadFailed: '参数读取失败',
  pointerSpeed: {
    titleWindows: 'Windows 指针速度',
    titleMac: '跟踪速度',
  },
  liftoffHeight: {
    title: '光学引擎静默高度',
  },
  sensorAngle: {
    title: '传感器角度',
  },
  wheelSpeed: {
    title: 'Windows 滚轮速度',
    wheelLinesTitle: '滚动整行',
    wheelLinesDesc: '一次滚动按照设置的行数变化',
    wheelPageTitle: '滚动整页',
    wheelPageDesc: '一次滚动一整个页面',
  },
  reportRate: {
    title: '回报率',
  },
  keyDebounce: {
    title: '按键防抖延迟 (ms)',
    press: '按下去抖延迟',
    release: '抬起去抖延迟',
    tip: '低防抖延迟，可能会带来自动触发的风险',
  },
  glassTracking: {
    title: '玻璃追踪技术',
    description: '提升{sensor}引擎鼠标在玻璃介质表面的稳定性，非玻璃介质表面建议关闭',
  },
  switchGroup: {
    motionSync: {
      title: '移动同步',
      description: '移动对鼠标移动轨迹进行算法修正，提高追踪的稳定性',
    },
    lineCorrection: {
      title: '直线修正',
      description: '在鼠标直线移动时修正轨迹偏差，清除偏移抖动',
    },
    waveCorrection: {
      title: '波浪修正',
      description: '鼠标高DPI下调整波浪形抖动，平滑控制移动速度',
    },
  },
}
